export interface StrictErrorResponse {
    response: {
        data: {
            message: string
        }
    }
}

export function isStrictErrorResponse(
    error: unknown
): error is StrictErrorResponse {
    if (typeof error !== 'object' || error === null) {
        return false
    }

    const errorObj = error as Record<string, unknown>

    if (
        !('response' in errorObj) ||
        typeof errorObj.response !== 'object' ||
        errorObj.response === null
    ) {
        return false
    }

    const responseObj = errorObj.response as Record<string, unknown>

    if (
        !('data' in responseObj) ||
        typeof responseObj.data !== 'object' ||
        responseObj.data === null
    ) {
        return false
    }

    const dataObj = responseObj.data as Record<string, unknown>

    return 'message' in dataObj && typeof dataObj.message === 'string'
}
